import { Link as RouterLink, useLocation, Outlet } from 'react-router';
// material
import { styled } from '@mui/material/styles';
import { Card, Link, Container, Typography, Stack } from '@mui/material';
// layouts
import AuthLayout from 'src/layouts/AuthLayout';
// components
import Page from 'src/minimals/Page';
import { MHidden } from 'src/minimals/@material-extend';
import { PATH_AUTH } from 'src/routes/paths';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { Box } from '@mui/system';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const SectionStyle = styled(Box)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  backgroundColor:
    theme.palette.mode === 'light' && theme.palette.primary.darker,
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function AuthPageWrapper({ children }) {
  const { t } = useTranslation();
  const { pathname, state } = useLocation();
  const [upperInfo, setUpperInfo] = useState({
    upperMessage: t('login.noaccount.message'),
    upperLink: PATH_AUTH.register,
    upperLinkText: t('login.link.register'),
  });

  useEffect(() => {
    switch (pathname) {
      case `${PATH_AUTH.login}`:
        setUpperInfo({
          upperMessage: t('login.noaccount.message'),
          upperLink: PATH_AUTH.register,
          upperLinkText: t('login.link.register'),
        });
        break;
      case `${PATH_AUTH.register}`:
        setUpperInfo({
          upperMessage: t('register.haveaccount.message'),
          upperLink: PATH_AUTH.login,
          upperLinkText: t('register.link.login'),
        });
        break;

      default:
        setUpperInfo({
          upperMessage: t('login.noaccount.message'),
          upperLink: PATH_AUTH.register,
          upperLinkText: t('login.link.register'),
        });
        break;
    }
  }, [pathname, t]);

  return (
    <RootStyle title={t('page.authentication')}>
      <AuthLayout>
        {upperInfo.upperMessage}
        &nbsp;
        <Link
          underline="none"
          variant="subtitle2"
          component={RouterLink}
          to={upperInfo.upperLink}
          state={state}
        >
          {upperInfo.upperLinkText}
        </Link>
      </AuthLayout>

      <MHidden width="mdDown">
        <SectionStyle>
          <Stack gap={1} padding={5}>
            {/* <Typography variant="h1">{t('authpage.title')}</Typography>
            <Typography variant="h4">{t('authpage.subtitle')}</Typography> */}
            <Box>
              <img src="/logo_auth.png" alt="logo-treinco" />
            </Box>
            {/* <img
              src="https://cdn.discordapp.com/attachments/1197283208174247981/1197289735987671111/vipien_An_illustration_that_shows_the_concept_of_connected_hous_157a06a4-bc48-4030-9348-b031d9950a23.png?ex=65bab9f5&is=65a844f5&hm=aa9d7b1377779f1b226ce66ebec85054a73f8e863e21bf4e467c827de5f0425f&"
              alt="login"
            /> */}
          </Stack>
        </SectionStyle>
      </MHidden>

      <Container maxWidth="sm">
        <ContentStyle>
          <Outlet />
          {children}
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
